import { Button, Card, CardContent, CardHeader, CardTitle } from '@cibli/shared';
import { Power } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useInterviewContext } from '@/features/common/contexts/interview.context';
import { useAppManagement } from '@/features/common/hooks/useAppManagement';

interface Props {
  onClose: () => void;
}

export default function AppManagement({ onClose }: Props) {
  const { setSleepMode } = useInterviewContext();
  const { appReload } = useAppManagement();
  const { t } = useTranslation();

  const handleSleepMode = () => {
    setSleepMode(true);
    onClose();
  };

  const handleReload = () => {
    appReload();
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Power className="w-5 h-5 text-red-600" />
          {t('Settings.application')}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button onClick={handleReload} variant="outline" className="w-full h-12">
          {t('Settings.reloadApp')}
        </Button>

        <Button onClick={handleSleepMode} variant="outline" className="w-full h-12">
          {t('Settings.sleepMode')}
        </Button>
      </CardContent>
    </Card>
  );
}
